import { c as _c } from "react/compiler-runtime";
export const IconArrowDropUp = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.5814 14.5C7.40698 14.5 7.26647 14.4468 7.15988 14.3404C7.05329 14.234 7 14.1099 7 13.9681C7 13.9326 7.05814 13.8085 7.17442 13.5957L11.3895 9.73936C11.4864 9.65071 11.5833 9.58865 11.6802 9.55319C11.7771 9.51773 11.8837 9.5 12 9.5C12.1163 9.5 12.2229 9.51773 12.3198 9.55319C12.4167 9.58865 12.5136 9.65071 12.6105 9.73936L16.8256 13.5957C16.8837 13.6489 16.9273 13.7066 16.9564 13.7686C16.9855 13.8307 17 13.8972 17 13.9681C17 14.1099 16.9467 14.234 16.8401 14.3404C16.7335 14.4468 16.593 14.5 16.4186 14.5H7.5814Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
IconArrowDropUp.displayName = 'IconArrowDropUp';